import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reset, formValueSelector } from 'redux-form';
import { injectIntl } from 'react-intl';
import $ from 'jquery';


import * as actions from '../../actions';
import * as c from '../../constants';
import { getAddModalState } from '../../selectors';

import AddHotkeyForm from './forms/AddHotkeyForm';

import messages from '../../translation_hotkey_template';


class AddHotkeyModal extends Component {
  componentDidUpdate(prevProps) {
    const { isModalActive: prevState } = prevProps;
    const { isModalActive: currState } = this.props;

    if (prevState !== currState) {
      this.handleModalActive(currState);
    }
  }


  handleModalActive(showModal) {
    const { id, formId, resetAddModal, reset } = this.props;

    if (showModal) {
      $(`#${id}`).modal({
        closable: false,
        onHidden() {
          reset(formId);
          resetAddModal();
        }
      }).modal('show');
    } else {
      $(`#${id}`).modal('hide');
    }
  }


  render() {
    const { id, formId, isAddItem, intl } = this.props;

    return (
      <div className="ui small compact modal" id={id}>
        <i className="close icon" />
        <div className="header" style={{ paddingTop: 15 }}>
          {`${intl.formatMessage( messages.label_new )} ${isAddItem ? intl.formatMessage( messages.header_item ) : intl.formatMessage( messages.header_group )}`}
        </div>
        <div className="content ht-paddingless">
          <AddHotkeyForm formId={formId} />
        </div>
      </div>
    );
  } 
}


function mapStateToProps(state) {
  const formId = c.FORM_ID_ADD_MODAL;
  const { isModalActive = false } = getAddModalState(state);
  const getField = formValueSelector(formId);

  return {
    formId,
    isModalActive,
    isAddItem: c.FORM_ADD_TYPE_ITEM === getField(state, 'add_type')
  };
}


function mapDispatchToProps(dispatch) {
  const { resetAddModal } = actions;

  return bindActionCreators({
    reset,
    resetAddModal
  }, dispatch);
}


export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(AddHotkeyModal));

